import React from 'react';
import { Link } from 'react-router-dom';
import { getQueueTimeStatus, getPeopleCountStatus, STATUS_COLORS } from './concessionTheme';
import './concession.css';

const ConcessionCard = ({ locationData, data }) => {
    const name = locationData.name;

    // Determine if this is count mode or queue mode
    const isCountMode = data?.type === 'people count';
    const displayValue = isCountMode ? data?.averagePeopleCount || 0 : data?.averageQueueTime || 0;
    const status = isCountMode ? getPeopleCountStatus(displayValue, 20, 40) : getQueueTimeStatus(displayValue);
    const displayColor = STATUS_COLORS[status];

    const metricLabel = locationData.sections.length === 1
        ? (isCountMode ? 'Current Count' : 'Current Queue')
        : (isCountMode ? 'Average Count' : 'Average Queue');

    return (
        <Link
            to={`../locations/concession/${name.replace(/ /g, '-').toLowerCase()}`}
            state={{
                id: locationData.id,
                currentLocation: locationData,
            }}
            className="cx-card"
        >
            <div className="cx-card-header">
                <img
                    src={locationData.logoMobileURL}
                    alt={`${name} logo`}
                    className="cx-card-logo"
                />
                <h3 className="cx-card-name">{name}</h3>
            </div>

            <div className="cx-card-metric">
                <div className="cx-metric-label">
                    <span className="cx-status-dot" style={{ backgroundColor: displayColor }} />
                    {metricLabel}
                </div>
                <div className="cx-card-value" style={{ color: displayColor }}>
                    {displayValue}
                    <span className="cx-card-unit">{isCountMode ? 'people' : 'mins'}</span>
                </div>
            </div>

            <div className="cx-card-sections">
                <div className="cx-metric-label">Available at sections</div>
                <div className="cx-chip-row">
                    {locationData.sections.map((section) => (
                        <span className="cx-chip" key={section.sectionId}>
                            {section.sectionId}
                        </span>
                    ))}
                </div>
            </div>
        </Link>
    );
};

export default ConcessionCard;
